import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../hooks/useMetaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'medium' | 'large';
  className?: string;
  variant?: 'primary' | 'secondary';
  /** When true, fires AddToCart pixel event on click */
  fireAddToCart?: boolean;
}
export function CTAButton({
  children,
  onClick,
  size = 'medium',
  className = '',
  variant = 'primary',
  fireAddToCart = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (fireAddToCart) {
      trackAddToCart();
    }
    if (onClick) {
      onClick();
    } else {
      window.open('https://cocinaproductiva.com/cart/46911022334105:1', '_blank');
    }
  };
  const baseClasses = 'relative overflow-hidden inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 tracking-wide';
  const sizeClasses = size === 'large' ? 'px-10 py-5 text-lg md:text-xl' : 'px-8 py-4 text-base md:text-lg';
  const variantClasses = variant === 'primary' ? 'bg-gradient-to-r from-[#B2D18F] to-[#93C572] text-white shadow-[0px_8px_12px_rgba(0,0,0,0.3)] hover:shadow-[0px_10px_15px_rgba(0,0,0,0.4)] hover:from-[#93C572] hover:to-[#B2D18F] active:shadow-[0px_6px_10px_rgba(0,0,0,0.2)]' : 'bg-white text-coffee-dark border border-taupe-light hover:border-gold-matte hover:text-gold-matte shadow-md hover:shadow-xl';
  return <>
      <style data-id="element-105">
        {`
          @keyframes shine-cta {
            0%   { left: -75%; }
            100% { left: 125%; }
          }
          .cta-button-shine::before {
            content: '';
            position: absolute;
            top: 0;
            left: -75%;
            width: 50%;
            height: 100%;
            background: rgba(255,255,255,0.5);
            transform: skewX(-25deg);
            animation: shine-cta 3s infinite;
          }
        `}
      </style>
      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${variantClasses} ${variant === 'primary' ? 'cta-button-shine' : ''} ${className}`} data-id="element-106">
        {children}
      </motion.button>
    </>;
}